// extracted by mini-css-extract-plugin
export default {"container":"mta9d","noMargin":"Zej7a","left":"e2DOx","wrapper":"Rn59N","titleWrapper":"Mq0AZ","title":"_0Lo5M","descriptionWrapper":"ToZBj","description":"_5iXLo"};